import BaseError from "./BaseError";

export default class ValidationError extends BaseError {
  constructor(message: string, info?: any, cause?: Error) {
    super({
      statusCode: 422,
      message,
      info: info || null,
      cause,
    });
    this.name = "ValidationError";
  }
}
